import ParsedPoint from "./ParsedPoint";

const URL_PARAMETERS_DEVIDER_SIGN = "+";

class PointUrlParameterParser {
  constructor() {
    
  }

  static parse = paramsStr => {
    if (
      paramsStr == null ||
      paramsStr === "" ||
      paramsStr.length <= 1 ||
      !paramsStr.includes(URL_PARAMETERS_DEVIDER_SIGN)
    ) {
      return undefined;
    }
    const unparsedPoints = paramsStr.split(URL_PARAMETERS_DEVIDER_SIGN);
    if (unparsedPoints.length <= 1) {
      return undefined;
    }
    const parsedPoints = [];
    for (let i = 0; i < unparsedPoints.length; i++) {
      const unparsedPoint = unparsedPoints[i];
      const parsedPoint = ParsedPoint.parse(unparsedPoint);
      if (!parsedPoint) {
        return undefined;
      }
      parsedPoints.push(parsedPoint);
    }
    return parsedPoints;
  };
  static toString = parsedPoints => parsedPoints ? parsedPoints.join(URL_PARAMETERS_DEVIDER_SIGN) : undefined;
}

export default PointUrlParameterParser;
